import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import Checkbox from "@mui/material/Checkbox";

import {changeUserInfo} from "../../../../../actions/actionFunctions";
import {ROUTES} from "../../../../../routes";

const GroheCartLoginRegisterCheckbox = (props) => {

  const {userInfo, changeUserInfo, history} = props;

  const termsButtonClick = (event) => {
    changeUserInfo({
      agreedToTerms: event.target.checked
    });
  }

  const goToTerms = () => {
    history.push(ROUTES.cartTerms)
  }

  return (
    <p className="look-checkbox">
      <Checkbox
        checked={userInfo.agreedToTerms}
        onChange={termsButtonClick}
      />
      <span className="look-secondary">
        <FormattedMessage id="look.register.termsText"/> <span className="look-link" onClick={goToTerms}>
          <FormattedMessage id="look.register.termsLink"/>
        </span>
      </span>
    </p>
  )
};

const mapStateToProps = (store) => {
  const {userInfo} = store.userState;
  return {
    userInfo,
  };
};

const mapDispatchToProps = {
  changeUserInfo,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartLoginRegisterCheckbox)
)
